import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { saveVisaPrepForm } from '../../../../../store/student/actions';
import { createUpdateVPIFieldAction } from '../../../../../store/student/visaPrepForm/actions';
import QuestionPage from '../../../../templates/question';
import { VQ } from '../../../../../store/student/types';
import { TextareaWithConfirm } from 'shared-components';

import { Pages } from '../../../../../store/student/visaPrepForm/types';
import { useNavigate } from 'react-router-dom';

const VisaPrepFormFeedbackPage1 = (_props: any) => {
  // dispatch actions
  const dispatch = useDispatch();

  const onNext = () => {
    dispatch(saveVisaPrepForm(Pages.PAGE8));
  };

  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(createUpdateVPIFieldAction(fieldName, value, refValue));

  const navigate = useNavigate();
  const onBackToTaskList = () => navigate(-1);

  // state props from store
  const visaPrepForm = useSelector(({ student }: ApplicationState) => student.visa, shallowEqual);
  const { otherFeedback, difficultiesFeedback } = visaPrepForm;

  // constants
  const currentStep = 1;
  const steps = 1;

  // component state
  const complete = true;

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={onNext}
      onBackToTaskList={onBackToTaskList}
      section={'Feedback'}
    >
      <TextareaWithConfirm
        key={VQ.OTHER_FEEDBACK}
        id={VQ.OTHER_FEEDBACK}
        value={otherFeedback}
        label={'Is there any other information you wish to be considered as part of your application?'}
        onChange={(evt: any) => onChange(VQ.OTHER_FEEDBACK, evt.currentTarget.value)}
      />

      <TextareaWithConfirm
        key={VQ.DIFFICULTIES_FEEDBACK}
        id={VQ.DIFFICULTIES_FEEDBACK}
        value={difficultiesFeedback}
        label={'If you have any difficulties with any question or require clarity, please list the question here:'}
        onChange={(evt: any) => onChange(VQ.DIFFICULTIES_FEEDBACK, evt.currentTarget.value)}
      />
    </QuestionPage>
  );
};
export default VisaPrepFormFeedbackPage1;
